/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { INamed } from './INamed';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class ServerVariable extends ExtensibleNode implements INamed {
    public _name : string;

    public enum_ : Array<string>;

    public default_ : string;

    public description : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.enum_===undefined) this.enum_ = null;
        if(this.default_===undefined) this.default_ = null;
        if(this.description===undefined) this.description = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }
}
ServerVariable["__class"] = "io.apicurio.datamodels.core.models.common.ServerVariable";
ServerVariable["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




